// redux/actions/testimonials.js
import { instance } from "./instance";
import {
  GET_TESTIMONIALS_REQUEST,
  GET_TESTIMONIALS_SUCCESS,
  GET_TESTIMONIALS_FAILURE,
} from "./actionTypes";

export const fetchTestimonials = () => async (dispatch) => {
  dispatch({ type: GET_TESTIMONIALS_REQUEST });
  try {
    const { data } = await instance.get("/testimonials");
    dispatch({ type: GET_TESTIMONIALS_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: GET_TESTIMONIALS_FAILURE,
      payload: err.response?.data?.message || err.message,
    });
  }
};
